import { required, useTranslate } from "ra-core";
import { useWatch } from "react-hook-form";
import { TextInput } from "@/components/admin/text-input";
import { SelectInput } from "@/components/admin/select-input";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { validateRevista } from "./campaignUtils";

export function CampaignInputs() {
  const { revistas } = useConfigurationContext();
  const tipo = useWatch({ name: "tipo" });
  const translate = useTranslate();

  const revistaChoices = (revistas || []).map((r) => ({
    id: r.value,
    name: r.label,
  }));
  const tipoChoices = [
    {
      id: "edicao",
      name: translate("resources.campaigns.tipos.edicao", { _: "Edição" }),
    },
    {
      id: "periodo",
      name: translate("resources.campaigns.tipos.periodo", { _: "Período" }),
    },
    {
      id: "evento",
      name: translate("resources.campaigns.tipos.evento", { _: "Evento" }),
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <TextInput source="name" validate={required()} />
      <SelectInput source="tipo" choices={tipoChoices} validate={required()} />
      {tipo === "edicao" && (
        <SelectInput
          source="revista"
          choices={revistaChoices}
          validate={validateRevista}
        />
      )}
      <TextInput source="data_inicio" type="date" />
      <TextInput source="data_fim" type="date" />
    </div>
  );
}
